import PageHandlersService from '@/utils/page-handlers-service';

const pageHandlers = new PageHandlersService();

const init = () => {
    // Открытие / закрытие
    const reviewButtons = document.querySelectorAll<HTMLElement>('.js-reviews-slider-slide__btn');
    const popupElements = document.querySelectorAll<HTMLElement>('.js-review-popup');

    reviewButtons.forEach((reviewBtn) => {
        const reviewId = reviewBtn.dataset.id;

        if (reviewId) {
            const popupElement = document.querySelector(`.js-review-popup[data-id="${reviewId}"]`);

            const handleOpenPopup = () => {
                popupElements.forEach((popupElement) => {
                    popupElement.classList.add('synchronized');
                    popupElement.classList.remove('active');
                });

                if (popupElement) {
                    popupElement.classList.add('active');
                }

                document.body.classList.add('no-scroll');
            };

            const handleClosePopup = () => {
                popupElements.forEach((popupElement) => {
                    popupElement.classList.remove('synchronized');
                });

                if (popupElement) {
                    popupElement.classList.remove('active');
                }

                document.body.classList.remove('no-scroll');
            };

            pageHandlers.set(reviewBtn, () => {
                if (popupElement) {
                    if (popupElement.classList.contains('active')) {
                        handleClosePopup();
                    } else {
                        handleOpenPopup();
                    }
                }
            });

            if (popupElement) {
                const closeButton = popupElement.querySelector('.js-reviews-popup-close');

                if (closeButton) {
                    pageHandlers.set(closeButton, handleClosePopup);
                }
            }

            pageHandlers.set(document, handleClosePopup);

            pageHandlers.set(reviewBtn, (event) => event.stopPropagation());

            popupElements.forEach((popupElement) => {
                pageHandlers.set(popupElement, (event) => event.stopPropagation());
            });
        }
    });
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
